import {cDisplay} from '../creator/cDisplay'
import { cButton } from '../creator/cGameObjects/cButton';
import { cContainer } from '../creator/cGameObjects/cContainer';
import { cInlineDisplay } from '../creator/cGameObjects/cInlineDisplay';
import { cSprite } from '../creator/cGameObjects/cSprite';
import { cText } from "../creator/cGameObjects/cText";
import {cScene} from '../creator/cScene'
import { ScreenItem } from '../creator/dataTypes';


export class gameElectionCheck extends cDisplay {

  private idlist: number[]
  private DATA: any
  private curNumber:number
  private score:number = 9

  init(){
    super.init()
    console.log('INIT gameElectionCheck');

    var rnd = new Phaser.Math.RandomDataGenerator();
    this.idlist = rnd.shuffle([1,2,3,4,5,6,7,8,9,10])

    var cS:cScene = this.scene as cScene;
    var DATA:any = 

    (this.scene as cScene).ev.addListener('action',(a,b,c)=>{

      switch (b.command){    
        case 'select_next_id':
          var h = this.getByName('holder');
          this.curNumber = this.idlist.pop();
          var ref = h.getByName('ausw_'+this.curNumber)
          h.getAll().forEach((r)=>{
            r.name != 'hand' && r.name != 'daumen' ?  r.visible=false : '' ;
          });
          ref.visible = true
          break;  
        case 'eval_answer':
          var resultValue = this.DATA[ String(this.curNumber) ][0]
          var answerValue = Number(b.payload.result) == 1 ? '1' : '0'
          if (String(resultValue) == answerValue){
            console.log('CORRECT')
            cS.triggerSceneEvent('correct',{
              'info':  this.DATA[ String(this.curNumber) ][2]
            })
            
          }else{
            console.log('ERROR')
            this.score -= this.score > 1 ? 1 : 0
            cS.triggerSceneEvent('error',{
              'title': this.DATA['window_title'],
              'info':  this.DATA[ String(this.curNumber) ][1]
            })
          }
          break;
        case 'check_next':
          if (this.idlist.length === 0){          
            cS.triggerSceneEvent('completed',{
              score: this.score
            })
          }else{
            cS.triggerSceneEvent('next')
          }
      }
    })

  }

  buildScene(){    
    super.buildScene();
    this.DATA = (this.getByName('DATA') as cContainer).modules.data._extraData
    console.log('>>',this.DATA)
  }



}
